/* eslint-disable class-methods-use-this */
import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  StatusResponse,
  TagBare,
  TagCreate,
  TagSubscription,
  TagUpdate,
} from 'SharedDir/declarations/tag';
import { TAGS, tagsUrl } from 'SharedDir/backend/endpoints/tags';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class TagsApiClass extends SimpleApi<TagBare, TagCreate, TagUpdate> {
  constructor() {
    super(tagsUrl);
  }

  public async subscription(form: TagSubscription): Promise<StatusResponse> {
    const { data } = (await http({
      ...TAGS.SUBSCRIPTION,
      data: form,
    })) as AxiosResponse<StatusResponse>;
    return data;
  }

  public async getPublicPaginated<Extra extends object>(params: PaginationParams<Extra>) {
    const { data } = (await http({
      ...TAGS.PUBLIC,
      params,
    })) as AxiosResponse<Paginated<TagBare, Extra>>;
    return data;
  }
}
